import type { LibraryState } from "./types";
import { config, storageKey } from "./config";
export const emptyLibrary = (): LibraryState => ({
  saved: [],
  unlocked: {},
  progress: {},
});
export function readLibrary(): LibraryState {
  try {
    const value = JSON.parse(
      localStorage.getItem(storageKey("library")) || "null",
    );
    if (
      !value ||
      !Array.isArray(value.saved) ||
      !value.unlocked ||
      !value.progress
    )
      return emptyLibrary();
    const unlocked: LibraryState["unlocked"] = {};
    const progress: LibraryState["progress"] = {};
    for (const [id, episodes] of Object.entries(value.unlocked)) {
      if (config.demo && Array.isArray(episodes))
        unlocked[id] = episodes.filter((ep) => Number.isInteger(ep) && ep > 0);
    }
    for (const [id, entry] of Object.entries(value.progress)) {
      const item = entry as Record<string, unknown> | null;
      if (
        item &&
        Number.isInteger(item.episode) &&
        Number(item.episode) > 0 &&
        typeof item.seconds === "number" &&
        Number.isFinite(item.seconds) &&
        item.seconds >= 0 &&
        typeof item.updatedAt === "number"
      ) {
        progress[id] = {
          episode: Number(item.episode),
          seconds: item.seconds,
          updatedAt: item.updatedAt,
        };
      }
    }
    return {
      saved: value.saved.filter((x: unknown) => typeof x === "string"),
      unlocked,
      progress,
    };
  } catch {
    return emptyLibrary();
  }
}
export function saveLibrary(value: LibraryState): boolean {
  try {
    localStorage.setItem(storageKey("library"), JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}
export function recordEvent(
  name: string,
  properties: Record<string, unknown> = {},
) {
  if (!config.demo) return; // Real analytics awaits server integration and consent handling.
  try {
    const events = JSON.parse(
      localStorage.getItem(storageKey("events")) || "[]",
    );
    const query = new URLSearchParams(location.search);
    if (query.has("utm_source") || query.has("fbclid")) {
      sessionStorage.setItem(
        storageKey("source"),
        JSON.stringify({
          source: query.get("utm_source"),
          campaign: query.get("utm_campaign"),
          fbclid: query.get("fbclid"),
        }),
      );
    }
    const event = {
      id: crypto.randomUUID?.() || `${Date.now()}-${Math.random()}`,
      name,
      time: new Date().toISOString(),
      properties,
      attribution: JSON.parse(
        sessionStorage.getItem(storageKey("source")) || "{}",
      ),
    };
    localStorage.setItem(
      storageKey("events"),
      JSON.stringify([...events, event].slice(-150)),
    );
  } catch {
    /* Storage is optional for the preview. */
  }
}
